export default __webpack_public_path__ + "static/media/plus.a7fd3ce9.svg";